import { CashReconciliationComponent } from './pages/cash-reconciliation/cash-reconciliation.component';
import { SquareReconciliationComponent } from './pages/square-reconciliation/square-reconciliation.component';
import { WorkloadForecastTestsComponent } from './tests/workload-forecast-tests/workload-forecast-tests.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { MaterialModule } from './material-module';
import { AutomationComponent } from './pages/automation/automation.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { InventoryCreateComponent } from './pages/inventory-create/inventory-create.component';
import { InventoryManagerComponent } from './pages/inventory-manager/inventory-manager.component';
import { InventoryNeedsImprovementsComponent } from './pages/inventory-needs-improvements/inventory-needs-improvements.component';
import { InventoryRepairQueueComponent } from './pages/inventory-repair-queue/inventory-repair-queue.component';
import { InventoryListComponent } from './pages/inventory-list/inventory-list.component';
import { InvoicesCreateComponent } from './pages/invoices-create/invoices-create.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { LoginComponent } from './pages/login/login.component';
import { NewItemTemplateComponent } from './pages/new-item-template/new-item-template.component';
import { PendingRevenueComponent } from './pages/pending-revenue/pending-revenue.component';
import { ProductsComponent } from './pages/products/products.component';
import { BankAccountSettingsComponent } from './pages/settings/bank-account-settings/bank-account-settings.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { TaskCreateComponent } from './pages/task-create/task-create.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { TestsComponent } from './pages/tests/tests.component';
import { TransactionsComponent } from './pages/transactions/transactions.component';
import { BankTransferTestsComponent } from './tests/bank-transfer-tests/bank-transfer-tests.component';
import { EbayTestsComponent } from './tests/ebay-tests/ebay-tests.component';
import { EmailTestsComponent } from './tests/email-tests/email-tests.component';
import { JobTestsComponent } from './tests/job-tests/job-tests.component';
import { PDFTestsComponent } from './tests/pdf-tests/pdf-tests.component';
import { SMSTestsComponent } from './tests/sms-tests/sms-tests.component';
import { TemplateTestsComponent } from './tests/template-tests/template-tests.component';
import { DialogLabComponent } from './tests/dialog-lab/dialog-lab.component';
import { QRGeneratorTestsComponent } from './tests/qr-generator-tests/qr-generator-tests.component';
import { MpdTestsComponent } from './tests/mpd-tests/mpd-tests.component';
import { InventoryComponent } from './pages/inventory/inventory.component';
import { AccountsComponent } from './pages/accounts/accounts.component';
import { SocialsComponent } from './pages/socials/socials.component';
import { AccountingComponent } from './pages/books/books.component';
import { KioskComponent } from './pages/kiosk/kiosk.component';
import { ReceiptsComponent } from './pages/receipts/receipts.component';
import { RemoteComponent } from './pages/remote/remote.component';
import { PartsOrderedComponent } from './pages/parts-ordered/parts-ordered.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { SearchPageComponent } from './pages/search/search.component';
import { WeeklyReportComponent } from './reports/weekly-report/weekly-report.component';
import { WebsiteEnquiriesComponent } from './pages/website-enquiries/website-enquiries.component';
import { InvoiceMemoryImportComponent } from './pages/invoice-memory-import/invoice-memory-import.component';
import { PaymentLinkerOnceComponent } from './pages/payment-linker-once/payment-linker-once.component';
import { MusicComponent } from './pages/music/music.component';
import { SquareTestsComponent } from './tests/square-tests/square-tests.component';


const routes: Routes = [
  { canActivate: [AuthGuard], path: 'books/square-reconciliation', component: SquareReconciliationComponent },
  { canActivate: [AuthGuard], path: 'books/cash-reconciliation', component: CashReconciliationComponent },
  { canActivate: [AuthGuard], path: '', component: DashboardComponent },
  { canActivate: [AuthGuard], path: 'dashboard', component: DashboardComponent },
  { canActivate: [AuthGuard], path: 'search', component: SearchPageComponent },
  { canActivate: [AuthGuard], path: 'products', component: ProductsComponent },
  { canActivate: [AuthGuard], path: 'pending-revenue-old', component: PendingRevenueComponent },
  { canActivate: [AuthGuard], path: 'automation', component: AutomationComponent },
  { canActivate: [AuthGuard], path: 'weekly-report', component: WeeklyReportComponent },

  { canActivate: [AuthGuard], path: 'customers', component: CustomersComponent },

  { canActivate: [AuthGuard], path: 'accounts', component: AccountsComponent },
  { canActivate: [AuthGuard], path: 'transactions', component: TransactionsComponent },
  { canActivate: [AuthGuard], path: 'transactions/:account', component: TransactionsComponent },

  { canActivate: [AuthGuard], path: 'tasks', component: TasksComponent },
  { canActivate: [AuthGuard], path: 'tasks/create', component: TaskCreateComponent },
  { canActivate: [AuthGuard], path: 'tasks/:taskID', component: TasksComponent },

  { canActivate: [AuthGuard], path: 'website-enquiries', component: WebsiteEnquiriesComponent },

  { path: 'invoices/completed', redirectTo: 'invoices/paid', pathMatch: 'full' },
  { canActivate: [AuthGuard], path: 'invoices/paid', component: InvoicesComponent, data: { tab: 'paid' } },
  { canActivate: [AuthGuard], path: 'invoices/reconciled', component: InvoicesComponent, data: { tab: 'reconciled' } },
  { canActivate: [AuthGuard], path: 'invoices/refunds', component: InvoicesComponent, data: { tab: 'refunds' } },
  { canActivate: [AuthGuard], path: 'invoices/payments', component: InvoicesComponent, data: { tab: 'payments' } },
  { canActivate: [AuthGuard], path: 'invoices/payment-linker-once', component: PaymentLinkerOnceComponent },
  { canActivate: [AuthGuard], path: 'invoices/memory-import', component: InvoiceMemoryImportComponent },
  { canActivate: [AuthGuard], path: 'invoices', component: InvoicesComponent },
  { canActivate: [AuthGuard], path: 'create-invoice', component: InvoicesCreateComponent },
  { canActivate: [AuthGuard], path: 'create-invoice/:type', component: InvoicesCreateComponent },
  { canActivate: [AuthGuard], path: 'edit-invoice/:invoice', component: InvoicesCreateComponent },

  { canActivate: [AuthGuard], path: 'settings', component: SettingsComponent },
  { canActivate: [AuthGuard], path: 'settings/bank-account-settings', component: BankAccountSettingsComponent },

  { canActivate: [AuthGuard], path: 'settings/item-template-editor/new', component: NewItemTemplateComponent },  

  { canActivate: [AuthGuard], path: 'tests', component: TestsComponent },
  { canActivate: [AuthGuard], path: 'tests/workload-forecast', component: WorkloadForecastTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/bank-transfer-tests', component: BankTransferTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/template-tests', component: TemplateTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/pdf-tests', component: PDFTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/dialog-lab', component: DialogLabComponent },
  { canActivate: [AuthGuard], path: 'tests/job-tests', component: JobTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/email-tests', component: EmailTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/sms-tests', component: SMSTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/ebay-tests', component: EbayTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/qr-generator-tests', component: QRGeneratorTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/mpd-tests', component: MpdTestsComponent },
  { canActivate: [AuthGuard], path: 'tests/square-tests', component: SquareTestsComponent },

  { path: 'login', component: LoginComponent },

  { canActivate: [AuthGuard], path: 'inventory', component: InventoryComponent },
  { canActivate: [AuthGuard], path: 'inventory/manager', component: InventoryManagerComponent },
  { canActivate: [AuthGuard], path: 'inventory/c/:category', component: InventoryListComponent },
  { canActivate: [AuthGuard], path: 'inventory/c/:category/:itemNumber', component: InventoryListComponent },
  { canActivate: [AuthGuard], path: 'inventory/create/:type', component: InventoryCreateComponent },
  { canActivate: [AuthGuard], path: 'inventory/create', component: InventoryCreateComponent },
  { canActivate: [AuthGuard], path: 'inventory/needs-improvements', component: InventoryNeedsImprovementsComponent },
  { canActivate: [AuthGuard], path: 'inventory/repair-queue', component: InventoryRepairQueueComponent },
  { canActivate: [AuthGuard], path: 'inventory/:itemNumber', component: InventoryListComponent },

  { canActivate: [AuthGuard], path: 'books/overview', component: AccountingComponent, data: {tab: "overview"} },
  { canActivate: [AuthGuard], path: 'books/financial-summary', component: AccountingComponent, data: {tab: "payroller-summary"} },
  { canActivate: [AuthGuard], path: 'books/payroller-summary', component: AccountingComponent, data: {tab: "payroller-summary"} },
  { canActivate: [AuthGuard], path: 'books/revenue', component: AccountingComponent, data: {tab: "revenue"} },
  { canActivate: [AuthGuard], path: 'books/expenses', component: AccountingComponent, data: {tab: "expenses"} },
  { canActivate: [AuthGuard], path: 'books/expenses/:expense', component: AccountingComponent, data: {tab: "expenses"} },
  { canActivate: [AuthGuard], path: 'books/pending-revenue', component: AccountingComponent, data: {tab: "pending-revenue"} },
  { canActivate: [AuthGuard], path: 'books/wages', component: AccountingComponent, data: {tab: "wages"} },
  { canActivate: [AuthGuard], path: 'books/accounts', component: AccountingComponent, data: {tab: "accounts"} },
  { canActivate: [AuthGuard], path: 'books/receipts', component: ReceiptsComponent },
  { canActivate: [AuthGuard], path: 'books/parts-ordered', component: PartsOrderedComponent },

  { canActivate: [AuthGuard], path: 'socials', component: SocialsComponent },
  { canActivate: [AuthGuard], path: 'remote', component: RemoteComponent },
  { canActivate: [AuthGuard], path: 'music', component: MusicComponent },

  { canActivate: [AuthGuard], path: 'kiosk', component: KioskComponent },
  { canActivate: [AuthGuard], path: 'calendar', component: CalendarComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,  {scrollPositionRestoration: 'enabled'}),
    MaterialModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
